import adIcon from 'flag-icons/flags/4x3/ad.svg?react';
import aeIcon from 'flag-icons/flags/4x3/ae.svg?react';
import afIcon from 'flag-icons/flags/4x3/af.svg?react';
import agIcon from 'flag-icons/flags/4x3/ag.svg?react';
import aiIcon from 'flag-icons/flags/4x3/ai.svg?react';
import alIcon from 'flag-icons/flags/4x3/al.svg?react';
import amIcon from 'flag-icons/flags/4x3/am.svg?react';
import aoIcon from 'flag-icons/flags/4x3/ao.svg?react';
import aqIcon from 'flag-icons/flags/4x3/aq.svg?react';
import arIcon from 'flag-icons/flags/4x3/ar.svg?react';
import asIcon from 'flag-icons/flags/4x3/as.svg?react';
import atIcon from 'flag-icons/flags/4x3/at.svg?react';
import auIcon from 'flag-icons/flags/4x3/au.svg?react';
import awIcon from 'flag-icons/flags/4x3/aw.svg?react';
import axIcon from 'flag-icons/flags/4x3/ax.svg?react';
import azIcon from 'flag-icons/flags/4x3/az.svg?react';
import baIcon from 'flag-icons/flags/4x3/ba.svg?react';
import bbIcon from 'flag-icons/flags/4x3/bb.svg?react';
import bdIcon from 'flag-icons/flags/4x3/bd.svg?react';
import beIcon from 'flag-icons/flags/4x3/be.svg?react';
import bfIcon from 'flag-icons/flags/4x3/bf.svg?react';
import bgIcon from 'flag-icons/flags/4x3/bg.svg?react';
import bhIcon from 'flag-icons/flags/4x3/bh.svg?react';
import biIcon from 'flag-icons/flags/4x3/bi.svg?react';
import bjIcon from 'flag-icons/flags/4x3/bj.svg?react';
import blIcon from 'flag-icons/flags/4x3/bl.svg?react';
import bmIcon from 'flag-icons/flags/4x3/bm.svg?react';
import bnIcon from 'flag-icons/flags/4x3/bn.svg?react';
import boIcon from 'flag-icons/flags/4x3/bo.svg?react';
import bqIcon from 'flag-icons/flags/4x3/bq.svg?react';
import brIcon from 'flag-icons/flags/4x3/br.svg?react';
import bsIcon from 'flag-icons/flags/4x3/bs.svg?react';
import btIcon from 'flag-icons/flags/4x3/bt.svg?react';
import bvIcon from 'flag-icons/flags/4x3/bv.svg?react';
import bwIcon from 'flag-icons/flags/4x3/bw.svg?react';
import byIcon from 'flag-icons/flags/4x3/by.svg?react';
import bzIcon from 'flag-icons/flags/4x3/bz.svg?react';
import caIcon from 'flag-icons/flags/4x3/ca.svg?react';
import ccIcon from 'flag-icons/flags/4x3/cc.svg?react';
import cdIcon from 'flag-icons/flags/4x3/cd.svg?react';
import ceftaIcon from 'flag-icons/flags/4x3/cefta.svg?react';
import cfIcon from 'flag-icons/flags/4x3/cf.svg?react';
import cgIcon from 'flag-icons/flags/4x3/cg.svg?react';
import chIcon from 'flag-icons/flags/4x3/ch.svg?react';
import ciIcon from 'flag-icons/flags/4x3/ci.svg?react';
import ckIcon from 'flag-icons/flags/4x3/ck.svg?react';
import clIcon from 'flag-icons/flags/4x3/cl.svg?react';
import cmIcon from 'flag-icons/flags/4x3/cm.svg?react';
import cnIcon from 'flag-icons/flags/4x3/cn.svg?react';
import coIcon from 'flag-icons/flags/4x3/co.svg?react';
import cpIcon from 'flag-icons/flags/4x3/cp.svg?react';
import crIcon from 'flag-icons/flags/4x3/cr.svg?react';
import cuIcon from 'flag-icons/flags/4x3/cu.svg?react';
import cvIcon from 'flag-icons/flags/4x3/cv.svg?react';
import cwIcon from 'flag-icons/flags/4x3/cw.svg?react';
import cxIcon from 'flag-icons/flags/4x3/cx.svg?react';
import cyIcon from 'flag-icons/flags/4x3/cy.svg?react';
import czIcon from 'flag-icons/flags/4x3/cz.svg?react';
import deIcon from 'flag-icons/flags/4x3/de.svg?react';
import dgIcon from 'flag-icons/flags/4x3/dg.svg?react';
import djIcon from 'flag-icons/flags/4x3/dj.svg?react';
import dkIcon from 'flag-icons/flags/4x3/dk.svg?react';
import dmIcon from 'flag-icons/flags/4x3/dm.svg?react';
import doIcon from 'flag-icons/flags/4x3/do.svg?react';
import dzIcon from 'flag-icons/flags/4x3/dz.svg?react';
import ecIcon from 'flag-icons/flags/4x3/ec.svg?react';
import eeIcon from 'flag-icons/flags/4x3/ee.svg?react';
import egIcon from 'flag-icons/flags/4x3/eg.svg?react';
import ehIcon from 'flag-icons/flags/4x3/eh.svg?react';
import erIcon from 'flag-icons/flags/4x3/er.svg?react';
import esIcon from 'flag-icons/flags/4x3/es.svg?react';
import esCtIcon from 'flag-icons/flags/4x3/es-ct.svg?react';
import esGaIcon from 'flag-icons/flags/4x3/es-ga.svg?react';
import etIcon from 'flag-icons/flags/4x3/et.svg?react';
import euIcon from 'flag-icons/flags/4x3/eu.svg?react';
import fiIcon from 'flag-icons/flags/4x3/fi.svg?react';
import fjIcon from 'flag-icons/flags/4x3/fj.svg?react';
import fkIcon from 'flag-icons/flags/4x3/fk.svg?react';
import fmIcon from 'flag-icons/flags/4x3/fm.svg?react';
import foIcon from 'flag-icons/flags/4x3/fo.svg?react';
import frIcon from 'flag-icons/flags/4x3/fr.svg?react';
import gaIcon from 'flag-icons/flags/4x3/ga.svg?react';
import gbIcon from 'flag-icons/flags/4x3/gb.svg?react';
import gbEngIcon from 'flag-icons/flags/4x3/gb-eng.svg?react';
import gbNirIcon from 'flag-icons/flags/4x3/gb-nir.svg?react';
import gbSctIcon from 'flag-icons/flags/4x3/gb-sct.svg?react';
import gbWlsIcon from 'flag-icons/flags/4x3/gb-wls.svg?react';
import gdIcon from 'flag-icons/flags/4x3/gd.svg?react';
import geIcon from 'flag-icons/flags/4x3/ge.svg?react';
import gfIcon from 'flag-icons/flags/4x3/gf.svg?react';
import ggIcon from 'flag-icons/flags/4x3/gg.svg?react';
import ghIcon from 'flag-icons/flags/4x3/gh.svg?react';
import giIcon from 'flag-icons/flags/4x3/gi.svg?react';
import glIcon from 'flag-icons/flags/4x3/gl.svg?react';
import gmIcon from 'flag-icons/flags/4x3/gm.svg?react';
import gnIcon from 'flag-icons/flags/4x3/gn.svg?react';
import gpIcon from 'flag-icons/flags/4x3/gp.svg?react';
import gqIcon from 'flag-icons/flags/4x3/gq.svg?react';
import grIcon from 'flag-icons/flags/4x3/gr.svg?react';
import gsIcon from 'flag-icons/flags/4x3/gs.svg?react';
import gtIcon from 'flag-icons/flags/4x3/gt.svg?react';
import guIcon from 'flag-icons/flags/4x3/gu.svg?react';
import gwIcon from 'flag-icons/flags/4x3/gw.svg?react';
import gyIcon from 'flag-icons/flags/4x3/gy.svg?react';
import hkIcon from 'flag-icons/flags/4x3/hk.svg?react';
import hmIcon from 'flag-icons/flags/4x3/hm.svg?react';
import hnIcon from 'flag-icons/flags/4x3/hn.svg?react';
import hrIcon from 'flag-icons/flags/4x3/hr.svg?react';
import htIcon from 'flag-icons/flags/4x3/ht.svg?react';
import huIcon from 'flag-icons/flags/4x3/hu.svg?react';
import icIcon from 'flag-icons/flags/4x3/ic.svg?react';
import idIcon from 'flag-icons/flags/4x3/id.svg?react';
import ieIcon from 'flag-icons/flags/4x3/ie.svg?react';
import ilIcon from 'flag-icons/flags/4x3/il.svg?react';
import imIcon from 'flag-icons/flags/4x3/im.svg?react';
import inIcon from 'flag-icons/flags/4x3/in.svg?react';
import ioIcon from 'flag-icons/flags/4x3/io.svg?react';
import iqIcon from 'flag-icons/flags/4x3/iq.svg?react';
import irIcon from 'flag-icons/flags/4x3/ir.svg?react';
import isIcon from 'flag-icons/flags/4x3/is.svg?react';
import itIcon from 'flag-icons/flags/4x3/it.svg?react';
import jeIcon from 'flag-icons/flags/4x3/je.svg?react';
import jmIcon from 'flag-icons/flags/4x3/jm.svg?react';
import joIcon from 'flag-icons/flags/4x3/jo.svg?react';
import jpIcon from 'flag-icons/flags/4x3/jp.svg?react';
import keIcon from 'flag-icons/flags/4x3/ke.svg?react';
import kgIcon from 'flag-icons/flags/4x3/kg.svg?react';
import khIcon from 'flag-icons/flags/4x3/kh.svg?react';
import kiIcon from 'flag-icons/flags/4x3/ki.svg?react';
import kmIcon from 'flag-icons/flags/4x3/km.svg?react';
import knIcon from 'flag-icons/flags/4x3/kn.svg?react';
import kpIcon from 'flag-icons/flags/4x3/kp.svg?react';
import krIcon from 'flag-icons/flags/4x3/kr.svg?react';
import kwIcon from 'flag-icons/flags/4x3/kw.svg?react';
import kyIcon from 'flag-icons/flags/4x3/ky.svg?react';
import kzIcon from 'flag-icons/flags/4x3/kz.svg?react';
import laIcon from 'flag-icons/flags/4x3/la.svg?react';
import lbIcon from 'flag-icons/flags/4x3/lb.svg?react';
import lcIcon from 'flag-icons/flags/4x3/lc.svg?react';
import liIcon from 'flag-icons/flags/4x3/li.svg?react';
import lkIcon from 'flag-icons/flags/4x3/lk.svg?react';
import lrIcon from 'flag-icons/flags/4x3/lr.svg?react';
import lsIcon from 'flag-icons/flags/4x3/ls.svg?react';
import ltIcon from 'flag-icons/flags/4x3/lt.svg?react';
import luIcon from 'flag-icons/flags/4x3/lu.svg?react';
import lvIcon from 'flag-icons/flags/4x3/lv.svg?react';
import lyIcon from 'flag-icons/flags/4x3/ly.svg?react';
import maIcon from 'flag-icons/flags/4x3/ma.svg?react';
import mcIcon from 'flag-icons/flags/4x3/mc.svg?react';
import mdIcon from 'flag-icons/flags/4x3/md.svg?react';
import meIcon from 'flag-icons/flags/4x3/me.svg?react';
import mfIcon from 'flag-icons/flags/4x3/mf.svg?react';
import mgIcon from 'flag-icons/flags/4x3/mg.svg?react';
import mhIcon from 'flag-icons/flags/4x3/mh.svg?react';
import mkIcon from 'flag-icons/flags/4x3/mk.svg?react';
import mlIcon from 'flag-icons/flags/4x3/ml.svg?react';
import mmIcon from 'flag-icons/flags/4x3/mm.svg?react';
import mnIcon from 'flag-icons/flags/4x3/mn.svg?react';
import moIcon from 'flag-icons/flags/4x3/mo.svg?react';
import mpIcon from 'flag-icons/flags/4x3/mp.svg?react';
import mqIcon from 'flag-icons/flags/4x3/mq.svg?react';
import mrIcon from 'flag-icons/flags/4x3/mr.svg?react';
import msIcon from 'flag-icons/flags/4x3/ms.svg?react';
import mtIcon from 'flag-icons/flags/4x3/mt.svg?react';
import muIcon from 'flag-icons/flags/4x3/mu.svg?react';
import mvIcon from 'flag-icons/flags/4x3/mv.svg?react';
import mwIcon from 'flag-icons/flags/4x3/mw.svg?react';
import mxIcon from 'flag-icons/flags/4x3/mx.svg?react';
import myIcon from 'flag-icons/flags/4x3/my.svg?react';
import mzIcon from 'flag-icons/flags/4x3/mz.svg?react';
import naIcon from 'flag-icons/flags/4x3/na.svg?react';
import ncIcon from 'flag-icons/flags/4x3/nc.svg?react';
import neIcon from 'flag-icons/flags/4x3/ne.svg?react';
import nfIcon from 'flag-icons/flags/4x3/nf.svg?react';
import ngIcon from 'flag-icons/flags/4x3/ng.svg?react';
import niIcon from 'flag-icons/flags/4x3/ni.svg?react';
import nlIcon from 'flag-icons/flags/4x3/nl.svg?react';
import noIcon from 'flag-icons/flags/4x3/no.svg?react';
import npIcon from 'flag-icons/flags/4x3/np.svg?react';
import nrIcon from 'flag-icons/flags/4x3/nr.svg?react';
import nuIcon from 'flag-icons/flags/4x3/nu.svg?react';
import nzIcon from 'flag-icons/flags/4x3/nz.svg?react';
import omIcon from 'flag-icons/flags/4x3/om.svg?react';
import paIcon from 'flag-icons/flags/4x3/pa.svg?react';
import peIcon from 'flag-icons/flags/4x3/pe.svg?react';
import pfIcon from 'flag-icons/flags/4x3/pf.svg?react';
import pgIcon from 'flag-icons/flags/4x3/pg.svg?react';
import phIcon from 'flag-icons/flags/4x3/ph.svg?react';
import pkIcon from 'flag-icons/flags/4x3/pk.svg?react';
import plIcon from 'flag-icons/flags/4x3/pl.svg?react';
import pmIcon from 'flag-icons/flags/4x3/pm.svg?react';
import pnIcon from 'flag-icons/flags/4x3/pn.svg?react';
import prIcon from 'flag-icons/flags/4x3/pr.svg?react';
import psIcon from 'flag-icons/flags/4x3/ps.svg?react';
import ptIcon from 'flag-icons/flags/4x3/pt.svg?react';
import pwIcon from 'flag-icons/flags/4x3/pw.svg?react';
import pyIcon from 'flag-icons/flags/4x3/py.svg?react';
import qaIcon from 'flag-icons/flags/4x3/qa.svg?react';
import reIcon from 'flag-icons/flags/4x3/re.svg?react';
import roIcon from 'flag-icons/flags/4x3/ro.svg?react';
import rsIcon from 'flag-icons/flags/4x3/rs.svg?react';
import ruIcon from 'flag-icons/flags/4x3/ru.svg?react';
import rwIcon from 'flag-icons/flags/4x3/rw.svg?react';
import saIcon from 'flag-icons/flags/4x3/sa.svg?react';
import sbIcon from 'flag-icons/flags/4x3/sb.svg?react';
import scIcon from 'flag-icons/flags/4x3/sc.svg?react';
import sdIcon from 'flag-icons/flags/4x3/sd.svg?react';
import seIcon from 'flag-icons/flags/4x3/se.svg?react';
import sgIcon from 'flag-icons/flags/4x3/sg.svg?react';
import shIcon from 'flag-icons/flags/4x3/sh.svg?react';
import siIcon from 'flag-icons/flags/4x3/si.svg?react';
import sjIcon from 'flag-icons/flags/4x3/sj.svg?react';
import skIcon from 'flag-icons/flags/4x3/sk.svg?react';
import slIcon from 'flag-icons/flags/4x3/sl.svg?react';
import smIcon from 'flag-icons/flags/4x3/sm.svg?react';
import snIcon from 'flag-icons/flags/4x3/sn.svg?react';
import soIcon from 'flag-icons/flags/4x3/so.svg?react';
import srIcon from 'flag-icons/flags/4x3/sr.svg?react';
import ssIcon from 'flag-icons/flags/4x3/ss.svg?react';
import stIcon from 'flag-icons/flags/4x3/st.svg?react';
import svIcon from 'flag-icons/flags/4x3/sv.svg?react';
import sxIcon from 'flag-icons/flags/4x3/sx.svg?react';
import syIcon from 'flag-icons/flags/4x3/sy.svg?react';
import szIcon from 'flag-icons/flags/4x3/sz.svg?react';
import tcIcon from 'flag-icons/flags/4x3/tc.svg?react';
import tdIcon from 'flag-icons/flags/4x3/td.svg?react';
import tfIcon from 'flag-icons/flags/4x3/tf.svg?react';
import tgIcon from 'flag-icons/flags/4x3/tg.svg?react';
import thIcon from 'flag-icons/flags/4x3/th.svg?react';
import tjIcon from 'flag-icons/flags/4x3/tj.svg?react';
import tkIcon from 'flag-icons/flags/4x3/tk.svg?react';
import tlIcon from 'flag-icons/flags/4x3/tl.svg?react';
import tmIcon from 'flag-icons/flags/4x3/tm.svg?react';
import tnIcon from 'flag-icons/flags/4x3/tn.svg?react';
import toIcon from 'flag-icons/flags/4x3/to.svg?react';
import trIcon from 'flag-icons/flags/4x3/tr.svg?react';
import ttIcon from 'flag-icons/flags/4x3/tt.svg?react';
import tvIcon from 'flag-icons/flags/4x3/tv.svg?react';
import twIcon from 'flag-icons/flags/4x3/tw.svg?react';
import tzIcon from 'flag-icons/flags/4x3/tz.svg?react';
import uaIcon from 'flag-icons/flags/4x3/ua.svg?react';
import ugIcon from 'flag-icons/flags/4x3/ug.svg?react';
import umIcon from 'flag-icons/flags/4x3/um.svg?react';
import unIcon from 'flag-icons/flags/4x3/un.svg?react';
import usIcon from 'flag-icons/flags/4x3/us.svg?react';
import uyIcon from 'flag-icons/flags/4x3/uy.svg?react';
import uzIcon from 'flag-icons/flags/4x3/uz.svg?react';
import vaIcon from 'flag-icons/flags/4x3/va.svg?react';
import vcIcon from 'flag-icons/flags/4x3/vc.svg?react';
import veIcon from 'flag-icons/flags/4x3/ve.svg?react';
import vgIcon from 'flag-icons/flags/4x3/vg.svg?react';
import viIcon from 'flag-icons/flags/4x3/vi.svg?react';
import vnIcon from 'flag-icons/flags/4x3/vn.svg?react';
import vuIcon from 'flag-icons/flags/4x3/vu.svg?react';
import wfIcon from 'flag-icons/flags/4x3/wf.svg?react';
import wsIcon from 'flag-icons/flags/4x3/ws.svg?react';
import xkIcon from 'flag-icons/flags/4x3/xk.svg?react';
import xxIcon from 'flag-icons/flags/4x3/xx.svg?react';
import yeIcon from 'flag-icons/flags/4x3/ye.svg?react';
import ytIcon from 'flag-icons/flags/4x3/yt.svg?react';
import zaIcon from 'flag-icons/flags/4x3/za.svg?react';
import zmIcon from 'flag-icons/flags/4x3/zm.svg?react';
import zwIcon from 'flag-icons/flags/4x3/zw.svg?react';

export const flagIcons = {
    'ad': adIcon,
    'ae': aeIcon,
    'af': afIcon,
    'ag': agIcon,
    'ai': aiIcon,
    'al': alIcon,
    'am': amIcon,
    'ao': aoIcon,
    'aq': aqIcon,
    'ar': arIcon,
    'as': asIcon,
    'at': atIcon,
    'au': auIcon,
    'aw': awIcon,
    'ax': axIcon,
    'az': azIcon,
    'ba': baIcon,
    'bb': bbIcon,
    'bd': bdIcon,
    'be': beIcon,
    'bf': bfIcon,
    'bg': bgIcon,
    'bh': bhIcon,
    'bi': biIcon,
    'bj': bjIcon,
    'bl': blIcon,
    'bm': bmIcon,
    'bn': bnIcon,
    'bo': boIcon,
    'bq': bqIcon,
    'br': brIcon,
    'bs': bsIcon,
    'bt': btIcon,
    'bv': bvIcon,
    'bw': bwIcon,
    'by': byIcon,
    'bz': bzIcon,
    'ca': caIcon,
    'cc': ccIcon,
    'cd': cdIcon,
    'cefta': ceftaIcon,
    'cf': cfIcon,
    'cg': cgIcon,
    'ch': chIcon,
    'ci': ciIcon,
    'ck': ckIcon,
    'cl': clIcon,
    'cm': cmIcon,
    'cn': cnIcon,
    'co': coIcon,
    'cp': cpIcon,
    'cr': crIcon,
    'cu': cuIcon,
    'cv': cvIcon,
    'cw': cwIcon,
    'cx': cxIcon,
    'cy': cyIcon,
    'cz': czIcon,
    'de': deIcon,
    'dg': dgIcon,
    'dj': djIcon,
    'dk': dkIcon,
    'dm': dmIcon,
    'do': doIcon,
    'dz': dzIcon,
    'ec': ecIcon,
    'ee': eeIcon,
    'eg': egIcon,
    'eh': ehIcon,
    'er': erIcon,
    'es': esIcon,
    'es-ct': esCtIcon,
    'es-ga': esGaIcon,
    'et': etIcon,
    'eu': euIcon,
    'fi': fiIcon,
    'fj': fjIcon,
    'fk': fkIcon,
    'fm': fmIcon,
    'fo': foIcon,
    'fr': frIcon,
    'ga': gaIcon,
    'gb': gbIcon,
    'gb-eng': gbEngIcon,
    'gb-nir': gbNirIcon,
    'gb-sct': gbSctIcon,
    'gb-wls': gbWlsIcon,
    'gd': gdIcon,
    'ge': geIcon,
    'gf': gfIcon,
    'gg': ggIcon,
    'gh': ghIcon,
    'gi': giIcon,
    'gl': glIcon,
    'gm': gmIcon,
    'gn': gnIcon,
    'gp': gpIcon,
    'gq': gqIcon,
    'gr': grIcon,
    'gs': gsIcon,
    'gt': gtIcon,
    'gu': guIcon,
    'gw': gwIcon,
    'gy': gyIcon,
    'hk': hkIcon,
    'hm': hmIcon,
    'hn': hnIcon,
    'hr': hrIcon,
    'ht': htIcon,
    'hu': huIcon,
    'ic': icIcon,
    'id': idIcon,
    'ie': ieIcon,
    'il': ilIcon,
    'im': imIcon,
    'in': inIcon,
    'io': ioIcon,
    'iq': iqIcon,
    'ir': irIcon,
    'is': isIcon,
    'it': itIcon,
    'je': jeIcon,
    'jm': jmIcon,
    'jo': joIcon,
    'jp': jpIcon,
    'ke': keIcon,
    'kg': kgIcon,
    'kh': khIcon,
    'ki': kiIcon,
    'km': kmIcon,
    'kn': knIcon,
    'kp': kpIcon,
    'kr': krIcon,
    'kw': kwIcon,
    'ky': kyIcon,
    'kz': kzIcon,
    'la': laIcon,
    'lb': lbIcon,
    'lc': lcIcon,
    'li': liIcon,
    'lk': lkIcon,
    'lr': lrIcon,
    'ls': lsIcon,
    'lt': ltIcon,
    'lu': luIcon,
    'lv': lvIcon,
    'ly': lyIcon,
    'ma': maIcon,
    'mc': mcIcon,
    'md': mdIcon,
    'me': meIcon,
    'mf': mfIcon,
    'mg': mgIcon,
    'mh': mhIcon,
    'mk': mkIcon,
    'ml': mlIcon,
    'mm': mmIcon,
    'mn': mnIcon,
    'mo': moIcon,
    'mp': mpIcon,
    'mq': mqIcon,
    'mr': mrIcon,
    'ms': msIcon,
    'mt': mtIcon,
    'mu': muIcon,
    'mv': mvIcon,
    'mw': mwIcon,
    'mx': mxIcon,
    'my': myIcon,
    'mz': mzIcon,
    'na': naIcon,
    'nc': ncIcon,
    'ne': neIcon,
    'nf': nfIcon,
    'ng': ngIcon,
    'ni': niIcon,
    'nl': nlIcon,
    'no': noIcon,
    'np': npIcon,
    'nr': nrIcon,
    'nu': nuIcon,
    'nz': nzIcon,
    'om': omIcon,
    'pa': paIcon,
    'pe': peIcon,
    'pf': pfIcon,
    'pg': pgIcon,
    'ph': phIcon,
    'pk': pkIcon,
    'pl': plIcon,
    'pm': pmIcon,
    'pn': pnIcon,
    'pr': prIcon,
    'ps': psIcon,
    'pt': ptIcon,
    'pw': pwIcon,
    'py': pyIcon,
    'qa': qaIcon,
    're': reIcon,
    'ro': roIcon,
    'rs': rsIcon,
    'ru': ruIcon,
    'rw': rwIcon,
    'sa': saIcon,
    'sb': sbIcon,
    'sc': scIcon,
    'sd': sdIcon,
    'se': seIcon,
    'sg': sgIcon,
    'sh': shIcon,
    'si': siIcon,
    'sj': sjIcon,
    'sk': skIcon,
    'sl': slIcon,
    'sm': smIcon,
    'sn': snIcon,
    'so': soIcon,
    'sr': srIcon,
    'ss': ssIcon,
    'st': stIcon,
    'sv': svIcon,
    'sx': sxIcon,
    'sy': syIcon,
    'sz': szIcon,
    'tc': tcIcon,
    'td': tdIcon,
    'tf': tfIcon,
    'tg': tgIcon,
    'th': thIcon,
    'tj': tjIcon,
    'tk': tkIcon,
    'tl': tlIcon,
    'tm': tmIcon,
    'tn': tnIcon,
    'to': toIcon,
    'tr': trIcon,
    'tt': ttIcon,
    'tv': tvIcon,
    'tw': twIcon,
    'tz': tzIcon,
    'ua': uaIcon,
    'ug': ugIcon,
    'um': umIcon,
    'un': unIcon,
    'us': usIcon,
    'uy': uyIcon,
    'uz': uzIcon,
    'va': vaIcon,
    'vc': vcIcon,
    've': veIcon,
    'vg': vgIcon,
    'vi': viIcon,
    'vn': vnIcon,
    'vu': vuIcon,
    'wf': wfIcon,
    'ws': wsIcon,
    'xk': xkIcon,
    'xx': xxIcon,
    'ye': yeIcon,
    'yt': ytIcon,
    'za': zaIcon,
    'zm': zmIcon,
    'zw': zwIcon,
};
